import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
  Loading,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select2 from "react-select";
const BookSubpackage = (props) => {
  const navigate = useNavigate();
  const { id, subpackageId } = useParams();
  const [optionsUsers, setOptionsUsers] = useState([]);
  const [isSaving, setIsSaving] = useState(true);
  const [ts, setTs] = useState("");
  const [user, setUser] = useState("");
  const [classType, setClassType] = useState("");
  const handleChangeUser = (newValue) => {
    setUser(newValue);
    setUserError("");
  };
  const [userError, setUserError] = useState("");
  const [method, setMethod] = useState("");
  const handleChangeMethod = (newValue) => {
    setMethod(newValue);
    setMethodError("");
  };
  const [methodError, setMethodError] = useState("");
  const [startDate, setStartDate] = useState("");
  const handleChangeStartDate = (newValue) => {
    setStartDate(newValue);
    setStartDateError("");
  };
  const [startDateError, setStartDateError] = useState("");

  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseUsers = "";
    try {
      responseUsers = await axios.get(`/app/users?get_all=1`);
      setOptionsUsers(
        responseUsers.data.data.map((item, index) => {
          return {
            label:
              item.id +
              " " +
              item.first_name +
              " " +
              item.last_name +
              ` (Email: ${item.email})`,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    setIsSaving(false);
  }
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "Booking has been done successfully"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [error, setError] = useState("");
  return (
    <Page
      narrowWidth
      backAction={{
        onAction: () =>
          navigate(
            `/admin/packages/${id}/subpackages/${subpackageId}/subscribers`
          ),
      }}
      title="Book"
    >
      {isSaving ? <Loading /> : null}

      <Card>
        <FormLayout>
          <Text>User</Text>
          <Select2
            options={optionsUsers}
            onChange={handleChangeUser}
            value={user}
            placeholder="Please select"
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            // menuPosition="absolute"
          />
          <InlineError message={userError}></InlineError>
          <TextField
            label="Start Date"
            value={startDate}
            onChange={handleChangeStartDate}
            type="date"
            error={startDateError}
          />
          <Select
            label="Payment Method"
            options={[
              { label: "Wallet", value: "wallet" },
              {
                label: "Offline Card",
                value: "offline_card",
              },
              { label: "Cash ", value: "cash" },
            ]}
            onChange={handleChangeMethod}
            value={method}
            error={methodError}
            placeholder="Please select"
          />
          <InlineError message={error} />
          <div style={{ height: "250px" }}></div>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    if (user === "" || method === "" || !startDate) {
      user === "" && setUserError("Please choose a user");
      method === "" && setMethodError("Please choose a method");
      !startDate && setStartDateError("This field is required");
    } else {
      setIsSaving(true);
      axios
        .post(`/packages/${id}/subpackages/${subpackageId}/purchase`, {
          user_id: user.value,
          payment_method: method,
          start_date: startDate,
        })
        .then((result) => {
          setIsSaving(false);
          toggleActive();
        })
        .catch((error) => {
          setError(error.response.data.message);
          setIsSaving(false);
        });
    }
  }
};

export default BookSubpackage;
